import xolor from "xolor";

const getReadableColor = (
  bgColor,
  lightColor = "#ffffff",
  darkColor = "#000000"
) => {
  let color;

  if (bgColor.length > 7) {
    const mode = document.querySelector("html").getAttribute("data-color-mode");
    const canvas = mode === "dark" ? "#1d2125" : "#ffffff";
    const mix = xolor(bgColor.substring(1, 7));

    const { hex } = mix.blend(
      canvas,
      parseInt(bgColor.substring(7, 9), 16) / 255
    ) || { hex: bgColor };

    color = hex.charAt(0) === "#" ? hex.substring(1, 7) : hex;
  } else {
    color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
  }

  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  const uicolors = [r / 255, g / 255, b / 255];
  const contrast = uicolors.map((col) => {
    if (col <= 0.03928) {
      return col / 12.92;
    }
    return Math.pow((col + 0.055) / 1.055, 2.4);
  });
  const L = 0.2126 * contrast[0] + 0.7152 * contrast[1] + 0.0722 * contrast[2];

  return L > 0.35 ? darkColor : lightColor;
};

export default getReadableColor;
